import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { BrowserWindow, BrowserWindowSymbol, MasterPageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { GetMotionEffectsInitCallback, MotionEffectsPageConfig, IMotionEffectsAPI } from '../types'
import { name, MotionEffectsInitCallbackSymbol } from '../symbols'
import { IPageProvider, PageProviderSymbol } from 'feature-pages'
import { REPEATER_DELIMITER } from '@wix/thunderbolt-commons'

const motionEffectsAPIFactory = (
	{ animationDefsByCompId }: MotionEffectsPageConfig,
	browserWindow: BrowserWindow,
	pageReflectorProvider: IPageProvider
): IMotionEffectsAPI => {
	return {
		triggerSoapMotionEffectsAnimation: async () => {
			const pageReflector = await pageReflectorProvider('masterPage', 'masterPage')
			const compIds = Object.keys(animationDefsByCompId || {})
			const [
				getMotionEffectsInitCallback,
			] = await pageReflector.getAllImplementersOnPageOfAsync<GetMotionEffectsInitCallback>(
				MotionEffectsInitCallbackSymbol
			)
			const motionEffectsInitCallback = getMotionEffectsInitCallback()
			const siteContainerElement: HTMLElement = browserWindow!.document.getElementById('SITE_CONTAINER')!
			compIds.forEach((compId) => {
				// match only component roots & Repeater Item roots
				const elementsToAnimate = siteContainerElement.querySelectorAll(
					`#${compId}, [id^="${compId}${REPEATER_DELIMITER}"]`
				)
				elementsToAnimate.forEach((element) => {
					if (motionEffectsInitCallback) {
						motionEffectsInitCallback(compId, element.id, element as HTMLElement)
					}
				})
			})
		},
	}
}

export const MotionEffectsAPIFactory = withDependencies(
	[named(MasterPageFeatureConfigSymbol, name), BrowserWindowSymbol, PageProviderSymbol],
	motionEffectsAPIFactory
)
